/*
 * Copies an announcement bar discount code to the clipboard.
 *
 * Delegated from the section root so codes inside rotating slider slides work
 * without per-slide listeners, and so the handler survives theme editor
 * re-renders of individual blocks.
 */
document.addEventListener('DOMContentLoaded', () => {
  const REVERT_DELAY = 1000;

  const bar = document.querySelector('.announcement-bar-section');
  if (!bar) return;

  const status = bar.querySelector('[data-copy-status]');
  let revertTimer = null;

  const markCopied = (button, code) => {
    const previous = bar.querySelector('.announcement-bar__copy.is-copied');
    previous?.classList.remove('is-copied');
    clearTimeout(revertTimer);

    button.classList.add('is-copied');
    if (status) status.textContent = status.dataset.copyStatus.replace('[code]', code);

    revertTimer = setTimeout(() => {
      button.classList.remove('is-copied');
      if (status) status.textContent = '';
    }, REVERT_DELAY);
  };

  bar.addEventListener('click', async (event) => {
    const button = event.target.closest('.announcement-bar__copy');
    if (!button) return;

    const code = button.dataset.copyCode;
    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);
      markCopied(button, code);
    } catch (error) {
      console.error('Announcement bar: could not copy discount code', error);
    }
  });
});
